import { ProjectSectionHeader } from '@/components/projects'
import { Button } from '@/components/ui/button'
import { AddIcon } from '@/components/icons'
import { useAuth } from '@/hooks'
import { Permissions, getEditablePromptPhases } from '@/lib/permissions'

interface PromptsHeaderProps {
  projectId: string
  onCreatePrompt: () => void
}

export function PromptsHeader({ projectId, onCreatePrompt }: PromptsHeaderProps) {
  const { hasPermission, getProjectRoles } = useAuth(projectId)
  const projectRoles = getProjectRoles(projectId)
  const hasEditablePhase = getEditablePromptPhases(projectRoles).length > 0

  return (
    <ProjectSectionHeader sectionName="Prompts">
      {hasEditablePhase && hasPermission(Permissions.Project.Prompt.Create, projectId) && (
        <Button onClick={onCreatePrompt}>
          <AddIcon />
          New Prompt
        </Button>
      )}
    </ProjectSectionHeader>
  )
}
